import { Data, Model } from '@singularsystems/neo-core';
import { AxiosPromise } from 'axios';
import { injectable } from 'inversify';
import { AppService, Types } from '../DomainTypes';
import DividendResolutionCriteria from "../../Reporting/Reports/DividendResolution/DividendResolutionCriteria";

export interface IReportingApiClient {

    getDividendResolutionFile(criteria: Model.PartialPlainObject<DividendResolutionCriteria>): AxiosPromise<Blob>;

    // Client only properties / methods
}

@injectable()
export default class ReportingApiClient extends Data.ApiClientBase implements IReportingApiClient {

    constructor (config = AppService.get(Types.App.Config)) {
        super(`${config.apiPath}/reporting`);
    }

    public getDividendResolutionFile(criteria: Model.PartialPlainObject<DividendResolutionCriteria>): AxiosPromise<Blob> {
        return this.axios.post(`${this.apiPath}/get-word-doc/dividend-resolution`, criteria, { responseType: "blob" });
    }

    // Client only properties / methods
}